angular.module('avant.customer_applications.directives').directive 'mask', ->
  restrict: 'A'
  link: (scope, elem, attr, ctrl) ->
    if attr.mask
      elem.mask attr.mask, scope.$eval(attr.config)
    return
